/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef } from 'react';
import profil from '../../assets/romain.jpg';

import { gsap } from 'gsap';

import './about.css';

function Word({ children, accent = false }) {
  return (
    <span className="word-mask">
      <span className={`word-inner${accent ? ' accent' : ''}`}>{children}</span>
    </span>
  );
}

export default function About() {
  const heroRef = useRef(null);

  useEffect(() => {
    const hero = heroRef.current;
    const glow = hero.querySelector('.hero-glow');

    // Le halo bleu suit légèrement le curseur dans le Hero.
    const onMove = (e) => {
      const r = hero.getBoundingClientRect();
      const x = e.clientX - r.left;
      const y = e.clientY - r.top;
      glow.style.transform = `translate(${(x - r.width * 0.5) * 0.08}px, ${(y - r.height * 0.5) * 0.08}px)`;
    };
    hero.addEventListener('mousemove', onMove);

    const tl = gsap.timeline({ defaults: { ease: 'power4.out' } });
    tl.from('.hero-badge', { duration: 0.7, opacity: 0, y: -16 })
      .to('.word-inner', {
        y: '0%',
        rotate: 0,
        opacity: 1,
        duration: 1,
        stagger: 0.045,
      }, '-=0.25')
      .from('.hero-bio', { duration: 0.9, opacity: 0, y: 24 }, '-=0.5')
      .from('.hero-actions', { duration: 0.8, opacity: 0, y: 18 }, '-=0.55')
      .from('.hero-facts > *', { duration: 0.7, opacity: 0, y: 18, stagger: 0.1 }, '-=0.5')
      .from('.profile-image-frame', { duration: 0.9, opacity: 0, scale: 0.75, ease: 'back.out(1.6)' }, '-=1')
      .from('.floating-chip', { duration: 0.7, opacity: 0, y: 24, stagger: 0.12 }, '-=0.4')
      .from('.social-link', { duration: 0.8, opacity: 0, y: 24 }, '-=0.3');

    return () => {
      hero.removeEventListener('mousemove', onMove);
      tl.kill();
    };
  }, []);

  return (
    <header id="about" className="hero" ref={heroRef}>
      <div className="hero-glow" aria-hidden="true"></div>
      <div className="hero-inner">
        {/* left column */}
        <div className="hero-text">
          <div className="hero-badge">
            <span className="hero-dot"></span>
            Disponible pour un poste ou une mission freelance
          </div>

          <h1 className="hero-title">
            <span className="line"><Word>Fullstack</Word> <Word>developer</Word></span>
            <br />
            <span className="line">
              <Word>passionné</Word> <Word>par</Word> <Word>le</Word> <Word accent>web</Word>.
            </span>
          </h1>

          <div className="hero-bio">
            <p>
              Hello, je suis <strong>Romain Danizel</strong>, développeur fullstack. Passionné par le développement web et le cinéma, je suis actuellement à la recherche d'un poste de développeur fullstack.
            </p>
            <p>
              J'ai débuté ma carrière de <strong>développeur web</strong> en 2019. J'ai travaillé sur plusieurs projets, notamment une application de gestion des données des employés au sein d'une équipe de développeurs, ainsi qu'un site e-commerce pour la vente de produits en ligne.
            </p>
            <p>
              Plutôt orienté <strong>back-end</strong> (NextJS, Express, Mongodb), je me suis aussi spécialisé côté <strong>front-end</strong> avec React et Wordpress pour construire des applications web de A à Z. Toujours curieux de nouvelles technologies et de nouveaux défis.
            </p>
          </div>

          <div className="hero-actions">
            <a href="#projects" className="btn btn-primary">Voir mes projets <span>↓</span></a>
            <a href="mailto:romain.danizel.pro@gmail.com" className="btn btn-secondary">Me contacter</a>
          </div>

          <div className="hero-facts">
            <div className="fact">
              <div className="fact-value">2019</div>
              <div className="fact-label">Début de carrière</div>
            </div>
            <div className="fact">
              <div className="fact-value">Fullstack</div>
              <div className="fact-label">Spécialité</div>
            </div>
            <div className="fact">
              <div className="fact-value">Web &amp; Cinéma</div>
              <div className="fact-label">Passions</div>
            </div>
          </div>
        </div>

        <div className="hero-photo-wrap">
          <div className="hero-photo-block"></div>
          <div className="profile-image-frame">
            <img src={profil} alt="Portrait de Romain Danizel" className="profile-image" />
          </div>

          <div className="floating-chip chip-1">⚛ React</div>
          <div className="floating-chip chip-2">▲ Next.js</div>

          <div className="social-link">
            <a href="https://github.com/Meanzar" className="social-icon github" aria-label="GitHub Profile" target="_blank" rel="noreferrer">
              <span className="sr-only">GitHub</span>
            </a>
            <a href="https://www.linkedin.com/in/romain-danizel-2757ba1a3/" className="social-icon linkedin" aria-label="LinkedIn Profile" target="_blank" rel="noreferrer">
              <span className="sr-only">LinkedIn</span>
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}
